import { ActionsPosition as ActionPositionComponent } from './ActionsPosition';

export default ActionPositionComponent;
